import { gsap } from "gsap";

export default class Accordions {
    constructor() {
        this.init();
    }

    init() {
        const accordionItems = gsap.utils.toArray(".accordion-item");
        const accordionHeaders = gsap.utils.toArray(".accordion-item_header");
        const accordionAnimations = [];

        accordionItems.forEach((accordionItem, index) => {
            const hasAttr = accordionItem.hasAttribute('data-default-open');
            const shouldBeOpen = hasAttr
                ? accordionItem.dataset.defaultOpen === 'true'
                : index === 0;

            this.createAnimation(accordionItem, accordionAnimations, shouldBeOpen);
        });

        accordionHeaders.forEach((accordionHeader) => {
            accordionHeader.addEventListener("click", () => {
                this.toggleAnimation(accordionHeader, accordionHeaders, accordionAnimations);
            });
        });
    }

    toggleAnimation(selectedHeader, accordionHeaders, accordionAnimations) {
        const isAlreadyActive = selectedHeader.classList.contains("active");

        accordionHeaders.forEach((header) => {
            header.classList.remove("active");
            header.animation.reversed(true);
        });

        if (!isAlreadyActive) {
            selectedHeader.classList.add("active");
            selectedHeader.animation.reversed(false);
        }
    }

    createAnimation(accordion, animationsArray, isActive) {
        const accordionHeader = accordion.querySelector(".accordion-item_header");
        const accordionContent = accordion.querySelector(".accordion-item_content");

        gsap.set(accordionContent, { height: "auto" });

        const tween = gsap.from(accordionContent, {
            height: 0,
            duration: 0.5,
            ease: "power1.inOut",
            reversed: !isActive,
        });

        accordionHeader.animation = tween;
        animationsArray.push(tween);

        if (isActive) {
            accordionHeader.classList.add("active");
        }
    }
}
